import { useState } from "react";
import styles from "./shipments-page.module.css";
import { useLocation, useSearch } from "wouter";
import IncompleteShipmentsTable from "../IncompleteShipmentsTable/IncompleteShipmentsTable";
import ShippedShipmentsTable from "../ShippedShipmentsTable/ShippedShipmentsTable";
import ClosedShipmentsTable from "../ClosedShipmentsTable/ClosedShipmentsTable";
import SellerAccountBanner from "@/components/SellerAccountBanner/SellerAccountBanner";
import Flex from "@/components/Flex/Flex";

enum ShipmentsTab {
  SHIPPED_SHIPMENTS = "shipped",
  INCOMPLETE_SHIPMENTS = "incomplete",
  CLOSED_SHIPMENTS = "closed",
}

export default function ShipmentsPage() {
  const [location, navigate] = useLocation();
  const searchString = useSearch();
  const [shipmentsTab, setShipmentsTab] = useState(() => {
    const searchParams = new URLSearchParams(searchString);
    return searchParams.get("tab") ?? ShipmentsTab.INCOMPLETE_SHIPMENTS;
  });

  const setAndReplaceShipmentsTab = (newTab: ShipmentsTab) => {
    setShipmentsTab(newTab);
    navigate(location + "?" + `tab=${newTab}`);
  };

  return (
    <div className={styles.pageContent}>
      <SellerAccountBanner />

      <Flex direction="row" gap={4} className={styles.tableHeader}>
        <div style={{flex: 1}}>
          <div className={styles.pillGroup}>
            <div
              className={`${styles.pill} ${shipmentsTab === ShipmentsTab.INCOMPLETE_SHIPMENTS ? styles.primary : ""}`}
              onClick={() => setAndReplaceShipmentsTab(ShipmentsTab.INCOMPLETE_SHIPMENTS)}
            >
              <span className="strong">Incomplete</span>
            </div>
            <div
              className={`${styles.pill} ${shipmentsTab === ShipmentsTab.SHIPPED_SHIPMENTS ? styles.primary : ""}`}
              onClick={() => setAndReplaceShipmentsTab(ShipmentsTab.SHIPPED_SHIPMENTS)}
            >
              <span className="strong">Shipped</span>
            </div>
            <div
              className={`${styles.pill} ${shipmentsTab === ShipmentsTab.CLOSED_SHIPMENTS ? styles.primary : ""}`}
              onClick={() => setAndReplaceShipmentsTab(ShipmentsTab.CLOSED_SHIPMENTS)}
            >
              <span className="strong">Closed</span>
            </div>
          </div>
        </div>
      </Flex>
      {(document.querySelector("[data-shipping-tab='shipped']") || shipmentsTab === ShipmentsTab.SHIPPED_SHIPMENTS) && <div data-shipping-tab="shipped" hidden={shipmentsTab !== ShipmentsTab.SHIPPED_SHIPMENTS}><ShippedShipmentsTable /></div>}
      {(document.querySelector("[data-shipping-tab='incomplete']") || shipmentsTab === ShipmentsTab.INCOMPLETE_SHIPMENTS) && <div data-shipping-tab="incomplete" hidden={shipmentsTab !== ShipmentsTab.INCOMPLETE_SHIPMENTS}><IncompleteShipmentsTable /></div>}
      {(document.querySelector("[data-shipping-tab='closed']") || shipmentsTab === ShipmentsTab.CLOSED_SHIPMENTS) && <div data-shipping-tab="closed" hidden={shipmentsTab !== ShipmentsTab.CLOSED_SHIPMENTS}><ClosedShipmentsTable /></div>}
    </div>
  );
}
